import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Descriptions, PageHeader, Tag } from 'antd';
import moment from 'moment';
import { observer } from 'mobx-react';
import RunStepsGraph from './components/RunStepsGraph';
import '@xyflow/react/dist/style.css';
import styles from './RunDetailView.module.scss';
const RunDetailView = ({ run, onBack }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: styles.runDetailViewContainer },
        React.createElement(PageHeader, { ghost: false, onBack: onBack, title: t('runDetailsTitle', 'Run Details: ...{{id}}', { id: run._id.slice(-6) }) },
            React.createElement(Descriptions, { size: "small", column: 2 },
                React.createElement(Descriptions.Item, { label: React.createElement(Trans, { i18nKey: "status", defaults: "Status" }) },
                    React.createElement(Tag, { color: run.success ? 'green' : 'red' }, run.success ? React.createElement(Trans, { i18nKey: "success", defaults: "Success" }) : React.createElement(Trans, { i18nKey: "failed", defaults: "Failed" }))),
                React.createElement(Descriptions.Item, { label: React.createElement(Trans, { i18nKey: "started", defaults: "Started" }) }, moment(run.started).format('YYYY-MM-DD HH:mm:ss')),
                React.createElement(Descriptions.Item, { label: React.createElement(Trans, { i18nKey: "versionTitle", defaults: "Version" }) }, run.version))),
        React.createElement("div", { className: styles.graphContainer },
            React.createElement(RunStepsGraph, { steps: run.steps || [] }))));
};
export default observer(RunDetailView);
